import {
  UserOutlined,
  PhoneOutlined,
  BankOutlined,
  BookOutlined,
  AppstoreOutlined,
  FileTextOutlined,
  UploadOutlined,
 
} from "@ant-design/icons";

const STEPSdata = [
  { title: "Resume Upload", icon: <UploadOutlined /> },

  { 
    title: "Personal Details", 
    icon: <UserOutlined /> 
  },

  { 
    title: "Professional Details", 
    icon: <BankOutlined /> 
  },

  { 
    title: "Application Details", 
    icon: <FileTextOutlined /> 
  },
];
export default STEPSdata;